import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
interface TransactionTypeChipProps {
  type: string;
  size?: 'small' | 'medium';
}

const TransactionTypeChip: React.FC<TransactionTypeChipProps> = ({ type, size = 'small' }) => {
  const { t } = useTranslation();
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'CREDIT':
        return '#2e7d32'; // Vert plus foncé et moins flashy
      case 'DEBIT':
        return '#c62828'; // Rouge plus foncé et moins flashy
      default:
        return '#616161'; // Gris plus foncé
    }
  };

  const getTypeLabel = (type: string) => {
    switch (type) {
      case 'CREDIT':
        return t('ADMIN_TRANSACTION_CREDITS');
      case 'DEBIT':
        return t('ADMIN_TRANSACTION_DEBITS');
      default:
        return type;
    }
  };

  const color = getTypeColor(type);
  const label = getTypeLabel(type);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        border: `1px solid ${color}`,
        borderRadius: '16px',
        padding: size === 'small' ? '2px 8px' : '4px 12px',
        backgroundColor: color,
        minWidth: '80px',
        justifyContent: 'center',
        opacity: 0.9
      }}
    >
      <Typography
        variant={size === 'small' ? 'body2' : 'body1'}
        sx={{
          color: "white",
          fontWeight: 500,
          lineHeight: 1.2
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default TransactionTypeChip; 